export default {
  BUTTON_PRIMARY_CLASS: 'cm_btn btn btn--default',
  BUTTON_SECONDARY_CLASS: 'cm_btn btn btn--clean',

  SEARCH_BOX_CLASS: 'mb-0',
  SEARCH_BOX_FORM_CLASS: 'd-flex align-items-lg-center hm-pg-desk',
  SEARCH_BOX_INPUT_CLASS: 'mb-0',
  SEARCH_BOX_BUTTON_CLASS: 'btn px-10',
  SEARCH_BOX_CLEAR_BUTTON: 'Clear',

  SELECT_YOUR_VEHICLE: 'Select Your Ford Vehicle',
  VEHICLE_WIDGET_COLLAPSIBLE_CLASS: 'container',
  CLEAR_TEXT: '<rt-virtual template="icons/reset" />',

  VEHICLE_CATEGORY_REPEATER_CLASS: 'mb-40 mb-lg-30',
};
